export const MARINE_PLATFORMS = Object.freeze(["shore", "boat_kayak"]);
export const marineContextRequired = (speciesId) => speciesId === "dicentrarchus_labrax";
export const explicitMarinePlatform = (value) => MARINE_PLATFORMS.includes(value) ? value : null;
export const compatibleAccess = (platform, value) => !(platform === "shore"
  ? ["open_water"] : platform === "boat_kayak"
    ? ["pier_jetty", "beach_surf", "rocky_shore", "riverbank", "lakebank"] : []).includes(value);
export const compatibleFeature = (platform, value) => !(platform === "shore"
  ? ["deep_water", "wreck_structure"] : []).includes(value);
